import {
  DealerGroup,
  DealerGroupMember,
  DealerGroupPreferences,
  DealerGroupsState
} from '../../interfaces/dealer-group.interface';
import { sortBy as _sortBy } from 'lodash';
import { reduceToRecord } from '../../../../util/util';
import { DealerGroupMemberDto } from 'remarketing-angular-library';

export function dtoToDealerGroups(
  dealerGroupMembers: DealerGroupMemberDto[],
  preferences: DealerGroupPreferences
): DealerGroupsState {
  const groupEntities: Record<string, DealerGroup> = {};
  const groupMembers: Record<string, DealerGroupMember[]> = {};
  // Extract group entries and members
  for (const member of dealerGroupMembers) {
    const groupUuid = member.dealerGroup.uuid;
    // Add the group if it doesn't exist
    if (typeof groupEntities[groupUuid] === 'undefined') {
      groupEntities[groupUuid] = { ...member.dealerGroup, memberOeUuids: [] };
    }
    if (typeof groupMembers[groupUuid] === 'undefined') {
      groupMembers[groupUuid] = [];
    }
    // Build the member record
    /// The preferences are a blocklist - every dealer in it is not selected
    const isSelected = !preferences.includes(member.organization.oeUuid);
    groupMembers[groupUuid].push({
      ...member.organization,
      isSelected
    });
  }
  // Build DealerGroupMembers
  const memberEntities: Record<string, DealerGroupMember> = {};
  Object.keys(groupMembers).forEach(id => {
    // Add keys of member dealerships
    const sortedMembers = _sortBy(groupMembers[id], [m => m.oeName.toLowerCase()]);
    groupEntities[id].memberOeUuids = sortedMembers.map(m => m.oeUuid);
    // Set selected for the group based on the member selections
    const newMemberEntities = reduceToRecord(sortedMembers, 'oeUuid');
    Object.assign(memberEntities, newMemberEntities);
  });

  const groupUuids = _sortBy(Object.values(groupEntities), [g => g.groupName.toLowerCase()]).map(g => g.uuid);
  const memberUuids = Object.keys(memberEntities);

  return { groupUuids, memberUuids, groupEntities, memberEntities };
}
